import styled from "styled-components";

export const ScanOptionContainer = styled.div`
  padding: 8px;
  width: 100%;
`;

export const HeaderWrapper = styled.div`
  font-size: var(--global-font-size-l);
  margin-bottom: 16px;
`;

export const TextWrapper = styled.p`
  max-width: 80ch;
  font-size: var(--global-font-size-s);
`;

export const AlignedStep = styled.div`
  display: flex;
  justify-content: space-between;
`;
